export default __webpack_public_path__ + "media/online-counselling.39506b29.png";